import React from "react";
import "./Home.css";
import { Text } from "./Home/Text";
import { FileSections } from "./Home/FileSections";
import { useState } from "react";

export const Home = () => {

  const [mode, setMode] = useState(0)

  return (
    <>
      <div id="alert-container">
        <div className="message" id="added">
          <div style={{ display: "inline-block" }}>
            <div className="icon">
              <i
                className="fa fa-arrow-up"
                style={{ color: "rgb(18, 214, 120)" }}
              ></i>
            </div>
            <div>
              <p className="txt" style={{ color: "rgb(18, 214, 120)" }}>
                Data Saved Successfully!!
              </p>
            </div>
          </div>
        </div>
        <div className="message" id="retrieved">
          <div className="icon">
            <i
              className="fa fa-arrow-down"
              style={{ color: "rgb(18, 214, 120)" }}
            ></i>
          </div>
          <div>
            <p className="txt" style={{ color: "rgb(18, 214, 120)" }}>
              Data Retrieved Successfully!!
            </p>
          </div>
        </div>
        <div className="message" id="failed">
          <div className="icon">
            <i className="fa fa-close" style={{ color: "rgb(251, 60, 60)" }}></i>
          </div>
          <div>
            <p className="txt" style={{ color: "rgb(252, 212, 212)" }}>
              Data Not Found!!
            </p>
          </div>
        </div>
      </div>
      <div id="mode_select">
        <button id="text" onClick={()=>{setMode(0); document.getElementById("home").style.height="1550px"}} style={{borderBottom: mode===0?"5px solid rgb(7, 101, 202)":"none"}}>Text</button>
        <button id="file" onClick={()=>{setMode(1); document.getElementById("home").style.height="900px"}} style={{borderBottom: mode===1?"5px solid rgb(7, 101, 202)":"none"}}>File</button>
      </div>
      <div id="home">
        { mode===0?<Text/>:<FileSections/>}
      </div>
    </>
  );
};
